// ==================================
// Componente Pagination
// ==================================

interface PaginationProps {
  pagina: number;
  totalPaginas: number;
  onCambiarPagina: (pagina: number) => void;
}

export function Pagination({
  pagina,
  totalPaginas,
  onCambiarPagina,
}: PaginationProps) {
  if (totalPaginas <= 1) return null;

  const paginas: (number | string)[] = [];
  const maxVisible = 5;

  if (totalPaginas <= maxVisible) {
    for (let i = 1; i <= totalPaginas; i++) {
      paginas.push(i);
    }
  } else {
    if (pagina <= 3) {
      paginas.push(1, 2, 3, 4, '...', totalPaginas);
    } else if (pagina >= totalPaginas - 2) {
      paginas.push(
        1,
        '...',
        totalPaginas - 3,
        totalPaginas - 2,
        totalPaginas - 1,
        totalPaginas
      );
    } else {
      paginas.push(1, '...', pagina - 1, pagina, pagina + 1, '...', totalPaginas);
    }
  }

  return (
    <nav className="flex items-center justify-between px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          onClick={() => onCambiarPagina(pagina - 1)}
          disabled={pagina === 1}
          className="btn-secondary"
        >
          Anterior
        </button>
        <button
          onClick={() => onCambiarPagina(pagina + 1)}
          disabled={pagina === totalPaginas}
          className="btn-secondary"
        >
          Siguiente
        </button>
      </div>

      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-stone-700">
            Página <span className="font-medium">{pagina}</span> de{' '}
            <span className="font-medium">{totalPaginas}</span>
          </p>
        </div>
        <div>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm">
            <button
              onClick={() => onCambiarPagina(pagina - 1)}
              disabled={pagina === 1}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-stone-400 ring-1 ring-inset ring-stone-300 hover:bg-stone-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {paginas.map((p, index) =>
              p === '...' ? (
                <span
                  key={`ellipsis-${index}`}
                  className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-stone-700 ring-1 ring-inset ring-stone-300"
                >
                  ...
                </span>
              ) : (
                <button
                  key={p}
                  onClick={() => onCambiarPagina(p as number)}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                    pagina === p
                      ? 'z-10 bg-primary-600 text-white'
                      : 'text-obsidian-900 ring-1 ring-inset ring-stone-300 hover:bg-stone-50'
                  }`}
                >
                  {p}
                </button>
              )
            )}

            <button
              onClick={() => onCambiarPagina(pagina + 1)}
              disabled={pagina === totalPaginas}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-stone-400 ring-1 ring-inset ring-stone-300 hover:bg-stone-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </nav>
  );
}

export default Pagination;
